import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router } from '../../../../../../node_modules/@angular/router';
import { NgProgress } from '../../../../../../node_modules/ngx-progressbar';
import { ShoppingCartService } from '../../../../services/shopping-cart.service';
import { CommonService } from '../../../../services/common.service';
import { FileService } from '../../../../services/file.service';
import { Subscription } from '../../../../../../node_modules/rxjs';
import { ShoppingCart } from '../../../../models/shopping-cart.model';
import { ApiResponse } from '../../../../models/api-response.model';
import { CurrentUserModel } from '../../../../models/account-ledger.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from "../../../../services/auth.service";
import { Store } from '@ngrx/store';
import { AppState } from '../../../../reducers';
import { getShoppingCartLoaded, getSelectedShoppingCart, getShoppingCarts } from '../../../../reducers/shoppingcart.reducer';
import { NgProgressService } from '../../../../services/ngProgress.service';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-send-cart-to-sales',
    templateUrl: './send-cart-to-sales.component.html',
    styleUrls: ['./send-cart-to-sales.component.css']
})
export class SendCartToSalesComponent implements OnInit, OnDestroy {

    title = 'Send Cart To Dicker Data Sales';
    setFullWindow = false;
    cartId: number;
    subscription: Subscription;
    accountSubscription: Subscription;
    subscriptionCartIdService: Subscription;
    shoppingCarts: ShoppingCart[];
    reasonText: string;
    emailText: string;
    file: any;
    formData = new FormData();
    email: string;
    isValid: boolean = true;
    sendingFinished: boolean = true;
    @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        private router: Router,
        private ngProgress: NgProgressService,
        private shoppingCartService: ShoppingCartService,
        private commonService: CommonService,
        private fileService: FileService,
        private authService: AuthService,
        private store: Store<AppState>
    ) { }

    ngOnInit() {

        this.ngProgress.start();


        this.store.select(getShoppingCartLoaded).subscribe((isLoaded) => {
            if (isLoaded) {
                this.subscriptionCartIdService = this.store.select(getSelectedShoppingCart).subscribe(cart => {
                    if (cart) {
                        this.cartId = cart.cartId;
                     }
                });

                this.subscription = this.store.select(getShoppingCarts).subscribe(sc => {
                    this.shoppingCarts = sc;
                }, (error: any) => {
                    console.error(error);
                    this.ngProgress.done();
                });
            }
        });

        // this.subscriptionCartIdService = this.shoppingCartService
        //     .currentCartId
        //     .subscribe(cn => {
        //         this.cartId = cn;
        //     },
        //         (error: any) => { console.error(error); });

        // this.subscription = this
        //     .shoppingCartService
        //     .getShoppingCart()
        //     .subscribe(sc => {
        //         this.shoppingCarts = sc;
        //     },
        //         (error: any) => {
        //             console.error(error);
        //             this.ngProgress.done();
        //         });

        this.accountSubscription = this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
            this.emailText = res.email;
            this.ngProgress.done();
        },
            (error: any) => {
                console.error(error);
                this.ngProgress.done();
            });
    }

    sendToSales(): void {
        this.isValid = true;

        this.notify.emit(false);
        this.ngProgress.start();
        if (!this.reasonText || !this.emailText) {
            this.commonService.showError('#divSending', "Please enter reason and contact email", 'right');
            this.isValid = false;
            this.ngProgress.done();
        }

        if (this.isValid) {
            this.sendingFinished = false;
            this.fileService.SendCartAsEmail(this.shoppingCarts
                .filter(x => x.cartId === this.cartId)[0].cartId, this.reasonText, this.emailText)
                .subscribe((res: ApiResponse) => {
                    this.sendingFinished = true;
                    if (res.status) {
                        this.commonService.showSuccess('#divSending', res.responseMessage, 'right');
                        setTimeout(() => {
                            this.close();
                            this.notify.emit(true);
                        }, 1000);
                        this.ngProgress.done();
                    } else {
                        this.commonService.showError('#divSending', res.responseMessage, 'right');
                        this.ngProgress.done();
                    }
                },
                    (error: any) => {
                        console.error(error);
                        this.commonService.showError('#divSending', error.responseMessage, 'right');
                        this.ngProgress.done();
                    });
        }

    }

    close() {
        this.ngProgress.done();
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.accountSubscription) {
            this.accountSubscription.unsubscribe();
        }
        if (this.subscriptionCartIdService) {
            this.subscriptionCartIdService.unsubscribe();
        }
    }

}
